import React, { ReactElement } from 'react';
import { Control, Controller } from 'react-hook-form';
import { ControlledFieldProps } from '../types';
import { RadioButton } from '../../RadioButton';
import { FormGroup } from '../../CiscoUi';

export interface ControlledRadioButtonProps<T extends Record<string, unknown>>
  extends Pick<ControlledFieldProps<T>, 'className' | 'control' | 'label'> {
  checked?: boolean;
  value: string;
  defaultValue?: boolean;
  customOnChange?: (e: React.MouseEvent<HTMLInputElement>) => void;
  name: string;
  inline?: boolean;
}

export function ControlledRadioButton<T extends Record<string, unknown>>({
  checked,
  control,
  defaultValue = false,
  label,
  customOnChange,
  value,
  name,
  inline = true,
}: ControlledRadioButtonProps<T>): ReactElement {
  return (
    <Controller
      name={name}
      control={control as Control}
      defaultValue={defaultValue}
      render={({ onChange }) => (
        <FormGroup inline={inline}>
          <RadioButton
            name={name}
            label={label}
            checked={checked}
            value={value}
            defaultChecked={defaultValue}
            onClick={(value) => {
              customOnChange && customOnChange(value);
              onChange(value);
            }}
          />
        </FormGroup>
      )}
    />
  );
}
